// angular
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params, Data } from '@angular/router';

/*
 *  This component is used for impersonation and enter account. Should be sent here from admin with a jwt.
 */
@Component({
  templateUrl: 'authentication-error.component.html',
  selector: 'app-authentication-error',
  styleUrls: ['./authentication-error.component.scss'],
})
export class AuthenticationErrorComponent implements OnInit {
  error: number;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.data.subscribe((data: Data) => {
      this.error = data.error;
    });
  }

  requestLogin(): void {
    // logout the user to break the Access Denied loop and then send the user back to the login page.
    this.router.navigate(['/logout']);
  }
}
